import { SessionStateAccessor } from './persisted-view-state.js';

const Key = {
  activeGameState: 'gameLink.gameState',
  activeGameUrl: 'gameLink.gameState.url',
  activeSessionId: 'gameLink.gameState.id',
  gameNetworkStatus: 'gameLink.network_status',
};

const NetworkStatus = {
  connected: 'connected',
  disconnected: 'disconnected',
  unauthed: 'unauthed',
};

const PersistKey = {
  sessionState: 'wg:gls',
};

export const GameLinkService = (props, { getState, setState, subscribe, Auth }) => {
  const sessionState = SessionStateAccessor(PersistKey.sessionState);

  const setGameUrl = (id, url) => {
    setState(Key.activeGameState, { url, id });
    sessionState.save({ activeGameUrl: url, sessionId: id });
  };

  const exitGame = async () => {
    const currentSessionId = getState(Key.activeSessionId);
    setState(Key.activeGameState, null);
    sessionState.clear();
    if (currentSessionId) {
      try {
        await Auth.fetch({ url: `/api/sessions/${currentSessionId}`, method: 'DELETE' });
      } catch (e) {
        console.error('Failed terminating session', e);
      }
    }
  };

  return {
    hooks: {
      onRegister: () => {
        const session = sessionState.fetch() ?? {};
        if (session.activeGameUrl && session.sessionId) {
          setGameUrl(session.sessionId, session.activeGameUrl);
        }

        console.log('Session', session);

        setState(Key.gameNetworkStatus, NetworkStatus.disconnected);
        window.addEventListener('message', message => {
          if (typeof message.data === 'object' && message.data && 'wg:type' in message.data) {
            const type = message.data['wg:type'];
            console.log('Got message of type', type, message.data, message.origin);
            if (type === 'game-status') {
              if (message.data.status === NetworkStatus.connected) {
                setState(Key.gameNetworkStatus, NetworkStatus.connected);
              } else if (message.data.status === NetworkStatus.disconnected) {
                setState(Key.gameNetworkStatus, NetworkStatus.disconnected);
              } else if (message.data.status === NetworkStatus.unauthed) {
                exitGame().catch(() => {});
              }
            }
          }
        });
      },
    },

    api: {
      send: msg => {
        console.log('Sending message', msg);
      },
      startGame: async id => {
        try {
          const response = await Auth.fetch({ url: `/api/games/${id}/start`, method: 'POST' });
          if (response.session_url && response.session_id) {
            setGameUrl(response.session_id, response.session_url);
          }
          return null;
        } catch (e) {
          console.error('Failed starting game', e);
          return e.message;
        }
      },
      isGameConnected: () => {
        return getState(Key.gameNetworkStatus, '') === NetworkStatus.connected;
      },
      isGameActive: () => {
        return getState(Key.activeGameUrl, '') !== '';
      },
      gameUrl: () => {
        return getState(Key.activeGameUrl, '');
      },
      exit: () => {
        exitGame().catch(() => {});
      },
    },
  };
};
